import axios from 'axios'
import { apiURL } from '@/settings'
import Cookies from 'js-cookie'
import { ElMessage } from 'element-plus'
import { decryptData } from '@/utils/encrypt';

//创建export到外部的服务名称, interceptors是定义axios的钩子函数，在get res之前做些事情
const service = axios.create({
    baseURL: apiURL,
    withCredentials : true,
    timeout: 60000,
})

// request 钩子函数，主要是使用token 检查是否是要验证权限
// config => === config() 实际上是返回了函数
// Promise.reject只会在request失败的时候才会调用
service.interceptors.request.use(config => {
    let token = Cookies.get('token')
    if (token) {
        // 把toekn信息填写到header里
        config.headers['Content-Type'] = 'application/json'
        config.headers.Authorization = "Bearer " + token
    }
    let tenant_id = decryptData(Cookies.get("tenant_id"));
    if (tenant_id) {
        config.headers['X-Tenant-ID'] = tenant_id
    }
    return config
}, (error) => Promise.reject(error))

// response 钩子函数，任何的response都会走到这个接口
service.interceptors.response.use(response => {
    const res = response.data
    if (response.status !== 200) {
        // 显示错误信息 利用message函数
        ElMessage.error("抱歉！您的远程服务调用失败，请联系系统管理员")
        ElMessage('res.code !== 0')
        return Promise.reject()
    }
    return res
}, (error) => {
    if (error.name == 'Error') {
        ElMessage.error({
            content: error.msg,
        })
    } else {
        ElMessage.error({
            content: error.response.data.data || error.message,
        })
    }
    return Promise.reject(error)
})

export default service